<template>
<div>
  <div :class="['w-full mx-auto px-4 ']">
    <form
      :class="[
        'w-full mb-8',
        hasKiosk ? 'flex flex-col items-center mt-6' : '',
      ]"
    >
      <div
        v-show="menu.show_number_of_guests"
        class="flex flex-wrap -mx-3 mb-2 w-64"
      >
        <div class="px-3">
          <label
            :class="[
              'z-10 block uppercase tracking-wide text-xs font-bold mb-2',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="full-name"
            >{{ lang["number_of_guests"][language] }}</label
          >
          <div
            :class="[
              'flex flex-row rounded-xl border-new-primary relative bg-white justify-center items-center border-1 mr-4 px-1 h-10',
            ]"
          >
            <button
              @click="removeFromNumberOfGuests()"
              type="button"
              :class="[
                'fill-current focus:outline-none inline-block h-10 w-4 rounded-full m-2',
              ]"
              :style="hasKiosk&&addButtonRadius"
            >
            <IconMinus/>
            </button>
            <input
              type="number"
              readonly
              :class="[
                'focus:outline-none h-6 w-12 bg-white  text-md md:text-basecursor-default flex items-center outline-none justify-center text-center pl-0 md:pl-3',
              ]"
              name="custom-input-number"
              :value="numberOfGuests"
              :style="makeStyles(userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            />
            <button
              @click="addToNumberOfGuests()"
              type="button"
              :class="[
                'h-6 w-4 rounded-full cursor-pointer focus:outline-none m-2',
              ]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="menu.is_checkout_name_enabled"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center  w-2/3 ' : '',
        ]"
      >
        <div :class="['w-full px-3']">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              hasKiosk ? 'text-gray-800' : 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="full-name"
            >{{ lang["full_name"][language] }}
          </label
          >
          <input
            :class="[
              'kioskInput appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none  rounded-xl  transition duration-500 text-black',
              hasKiosk
                ? 'focus:border-gray-800 border-1.5 border-gray-800'
                : 'focus:border-primary-300 border-1.5 border-product-gray',
            ]"
            :id="'full-name' + Math.random()"            
            @focus="show"
            autocomplete="off"
            data-layout="normal"
            v-model="fullName"
            type="text"
            pattern="[A-Za-z\W]+"
            maxlength="20"
            placeholder="John Doe"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            @click="getInputType($event)"
          />
        </div>
      </div>
      <div
        v-if="menu.rounds_enabled && !hasKiosk"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center  w-2/3 ' : '',
        ]"
      >
        <div :class="['w-full px-3']">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2 text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain)"
            for="menu-rounds"
            >{{ menu[`choose_company_label_${language}`] }}
          </label
          >
          <div class="custom-dropdown relative" :class="{ open: isOpen }">
          <div
          @click="toggleDropdown"
          :class="[
              'dropdown-header relative kioskInput appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none  rounded-xl  transition duration-500 text-black focus:border-primary-300 border-1.5 border-product-gray',
            ]"
          :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain)"
          >
          <span
            class="block text-black transition-colors"
            :class="{ 'text-gray-400': !selectedOption, 'hidden' : isOpen }"
            :style="makeStyles(hasKiosk && cartProcessInputRadius, inputBackground, inputBorder, titleMain)"
          >
            {{ selectedOption ? selectedOption : lang["please_select"][language] }}
          </span>
          <input
            ref="menuRoundInput"
            v-if="isOpen"
            type="text"
            @click.stop
            v-model="menuRoundInput"
            class="block w-full leading-tight focus:outline-none rounded-xl transition duration-500 text-black focus:border-primary-300 border-product-gray"
            :style="makeStyles(hasKiosk && cartProcessInputRadius, inputBackground, inputBorder, titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            :placeholder="lang['type_here'][language]"
          />
        </div>
        <transition
         name="dropdown">
          <ul 
            v-if="isOpen" 
            @transitionend="onTransitionEnd" 
            class="dropdown-menu w-full max-h-60 overflow-auto bg-white border border-gray-300 rounded-md shadow-lg">
            <li v-for="(option, index) in filteredMenuRounds"
             :key="index" 
              class="px-4 py-2 cursor-pointer hover:bg-gray-100"
             @click="selectOption(option)"
             :style="selectedOption == option.name ? selectedMenuRoundBackground : ''"
             >{{ option.name }}
            </li>
          </ul>
        </transition>
        </div>
        </div>
      </div>
      <transition name="fade">
      <div class="w-full" 
      id="elementToHide"
      v-show="((homeDelivery || this.menu.is_disable_takeaway_w_deliv) && !this.selectedOption) && this.menu.is_address_map_enabled">
        <div
          class="flex flex-wrap justify-center -mx-3 mb-2 m-auto"
          v-show="menu.enable_delivery || this.menu.is_disable_takeaway_w_deliv"
        >
          <div class="w-full px-3">
            <label
              :class="[
                'block uppercase tracking-wide text-xs font-bold mb-2',
                /* theme.body.textColor */ 'text-product-gray',
                menu.layout == 'frydate' ? 'text-4xl' : ''
              ]"
              :style="userDetailsLabelColor"
              for="full-name"
              >{{ lang["address"][language] }}</label
            >
            <p v-if="address" class="mb-1">
              {{ lang["current_chosen_address"][language] }}: {{ address }}
            </p>
            <DeliveryMap
              :value="$store.state.address"
              :origin="{
                latitude: $store.state.menu.delivery_base_lat,
                longitude: $store.state.menu.delivery_base_long,
              }"
              @change="deliveryAddress"
              class="mb-3"
            />
            <div
              class="flex flex-wrap -mx-3 mb-2"
              v-show="
                calculatedDistanceHomeDelivery >
                  this.menu.max_delivery_distance ||
                (calculatedDistanceHomeDelivery == 0 &&
                  this.menu.enable_delivery == true &&
                  homeDelivery &&
                  calculatedDistanceHomeDelivery != 0)
              "
            >
              <div class="w-full px-3">
                <label
                  :class="[
                    'block uppercase tracking-wide text-xs font-bold mb-2 text-red-600 mb-10',
                    menu.layout == 'frydate' ? 'text-4xl' : ''
                  ]"
                  :style="userDetailsLabelColor"
                  for="note"
                  >{{ lang["DeliveryDistanceOutOfRange"][language] }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      </transition>
      <div v-show="homeDelivery && !this.selectedOption && this.menu.is_address_map_enabled">
        <div class="flex flex-wrap -mx-3 mb-2" v-show="menu.enable_delivery">
          <div class="w-full px-3">
            <label
              :class="[
                'block uppercase tracking-wide text-xs font-bold mb-2',
                /* theme.body.textColor */ 'text-product-gray',
                menu.layout == 'frydate' ? 'text-4xl' : ''
              ]"
              :style="userDetailsLabelColor"
              for="busNumber"
              >{{ lang["bus_number"][language] }}</label
            >
            <input
              :class="[
                'appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-primary-300 border-1.5 border-product-gray rounded-xl  transition duration-500  text-black bg-white',
              ]"
              :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
              :id="'busNumber' + Math.random()"
              v-model="busNumber"
              type="text"
              placeholder="288"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!hasKiosk ? menu.is_checkout_email_enabled : false"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center  w-2/3 ' : '',
        ]"
      >
        <div class="w-full px-3" >
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              /* theme.body.textColor */ 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="email"
            >{{ lang["email"][language] }}</label
          >
          <input
            :class="[
              'kioskInput appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-primary-300 border-1.5 border-product-gray rounded-xl  transition duration-500',
            ]"
            :id="'email' + Math.random()"
            @focus="show"
            autocomplete="off"
            data-layout="normal"
            v-model="email"
            @blur="handleBlur"
            type="text"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            @click="getInputType('email')"
            placeholder="john@example.com"
          />
          <p v-if="errorEmail" class="text-red-600 mb-2 -mt-2 ml-2 h-6">
            <span v-if="errorEmail">{{
              lang["email_not_valid"][language]
            }}</span>
          </p>
        </div>
      </div>
      <div
        v-if="!hasKiosk ? menu.is_checkout_phone_enabled : menu.show_phone_number"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center w-2/3' : '',
        ]"
      >
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              hasKiosk ? 'text-gray-800' : 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="phone"
            >{{ lang["phone"][language] }}
          </label>
          <input
            :class="[
              'kioskInput appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-primary-300 border-1.5 border-product-gray rounded-xl  transition duration-500 ',

              hasKiosk
                ? 'focus:border-gray-800 border-1.5 border-gray-800'
                : 'focus:border-primary-300 border-1.5 border-product-gray',
            ]"
            :id="'phone' + Math.random()"
            @focus="show"
            data-layout="numeric"
            v-model="phone"
            type="number"
            maxlength="16"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius ,inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            placeholder="0xx xxxxxxx"
            @keypress="isNumber($event)"
          />
        </div>
      </div>
      <div
        v-if="menu.is_vat_number_enabled"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center  w-2/3 ' : '',
        ]"
      >
        <div :class="['w-full px-3']">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              hasKiosk ? 'text-gray-800' : 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="vat-number"
            >{{ lang["vat_number"][language] }}
            </label
          >
          <input
            :class="[
              'kioskInput appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none  rounded-xl  transition duration-500 text-black',
              hasKiosk
                ? 'focus:border-gray-800 border-1.5 border-gray-800'
                : 'focus:border-primary-300 border-1.5 border-product-gray',
            ]"
            :id="'vat-number' + Math.random()"
            @focus="show"
            autocomplete="off"
            data-layout="normal"
            v-model="vatNumber"
            type="text"
            placeholder="CC0123456789"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
            @click="getInputType($event)"
          />
        </div>
      </div>
      <div
        v-if="!hasKiosk&&menu.is_extra_input_field_enabled"
        class="flex flex-wrap -mx-3 mb-2"
      >
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              hasKiosk ? 'text-gray-800' : 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="extra-note"
            >
            {{ menu[`extra_input_field_${language}`] || lang["extra_note_label"][language] }}
          </label>
          <input
              v-model="extraNote"
              type="text"
              id="extra-note"
              :style="makeStyles(hasKiosk&& cartProcessInputRadius , inputBackground , inputBorder , titleMain, userDetailsInputBackgroundColor, userDetailsInputTextColor)"
              @focus="show"
              data-layout="normal"
            :class="[
              'appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-primary-300 border-1.5 border-product-gray rounded-xl  transition duration-500 ',
              hasKiosk
                ? 'focus:border-gray-800 border-1.5 border-gray-800'
                : 'focus:border-primary-300 border-1.5 border-product-gray',
            ]"
            :placeholder="menu[`extra_input_field_${language}`]"
          />
        </div>
      </div>
      <div
        v-if="(!hasKiosk && menu.show_note_field) || (hasKiosk && menu.is_checkout_number_enabled && isOrderTypeDineIn)"
        :class="[
          'flex flex-wrap -mx-3 mb-2',
          hasKiosk ? 'text-center w-2/3' : '',
        ]"
      >
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2',
              (hasKiosk && menu.is_checkout_number_enabled) ? 'text-gray-800' : 'text-product-gray',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="note"
          >
          <p v-if="(hasKiosk && menu.is_checkout_number_enabled)">
            {{lang['table_number'][language]}}
          </p>
          <p v-if="!hasKiosk">
            <!-- use if note_title_lang value is provided else use default note_label -->
            {{ menu[`note_title_${language}`] || lang["note_label"][language] }} ({{note.length}}/{{ maxPermissibleNoteLen }})
          </p>
          </label>
          <input 
            type="number"
            placeholder="00"
            v-if="(hasKiosk && menu.is_checkout_number_enabled)"
            v-model="note"
            :id="'note' + Math.random()"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius ,inputBackground , inputBorder , titleMain, userDetailsInputTextColor)"
            @focus="show"
            data-layout="numeric"
            :maxlength="maxPermissibleNoteLen"
            :class="[
              'appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 focus:border-primary-300 border-1.5 border-product-gray rounded-xl ',
            ]"
            />
          <textarea
            v-if="!hasKiosk && menu.show_note_field"
            v-model="note"
            :id="'note' + Math.random()"
            :style="makeStyles(hasKiosk&& cartProcessInputRadius ,inputBackground , inputBorder , titleMain)"
            @focus="show"
            data-layout="normal"
            rows="4"
            :maxlength="maxPermissibleNoteLen"
            :class="[
              'appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none transition duration-500 focus:border-primary-300 border-1.5 border-product-gray rounded-xl ',
            ]"
          ></textarea>
        </div>
      </div>
      <div
        class="flex flex-wrap -mx-3 mb-2"
        v-show="
          calculatedDistanceHomeDelivery > this.menu.max_delivery_distance ||
          (calculatedDistanceHomeDelivery == 0 &&
            this.menu.enable_delivery == true &&
            homeDelivery &&
            calculatedDistanceHomeDelivery != 0)
        "
      >
      
        <div class="w-full px-3">
          <label
            :class="[
              'block uppercase tracking-wide text-xs font-bold mb-2 text-red-600 mb-10',
              menu.layout == 'frydate' ? 'text-4xl' : ''
            ]"
            :style="userDetailsLabelColor"
            for="note"
            >{{ lang["DeliveryDistanceOutOfRange"][language] }}</label
          >
        </div>
      </div>
    </form>
  </div>
  <div class="w-full">
    <!-- <Keyboard 
      v-if="visible" 
      :cancel="hide"
      :accept="accept"
      :input="input"
    /> -->
    <vue-touch-keyboard
      v-if="visible"
      :cancel="hide"
      :accept="accept"
      :input="input"
      :options="{
        useKbEvents: false,
        preventClickEvent: false,
      }"
      :layout="layout"
    />
  </div>
</div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import DeliveryMap from "../components/DeliveryMap.vue";
import _ from 'lodash';
import { layouts } from "../utils/vendors/touch-keyboard.vue";
import IconMinus from "../components/icons/iconMinus.vue";
// const ClipLoader = require("vue-spinner/src/ClipLoader.vue").default;

export default {
  data() {
    return {
      lang: lang,
      loadingStatus: false,
      visible: false,
      input: undefined,
      layout: {},
      inputValue: "",
      isOpen: false,
      selectedOption: '',
      menuRoundInput: '',
    };
  },
  components: {
    DeliveryMap,
    IconMinus
},
  computed: {
    ...mapGetters([
      "language",
      "hasKiosk",
      "menuHash",
      "theme",
      "menu",
      "calculatedDistanceHomeDelivery",
      "country",
      "address",
      "city",
      "zip",
      "currentAddressesInSearch",
      "currentKioskMode",
      "busNumber",
      "errorEmail",
      "isMobileDevice",
      "isCickable",
    ]),
    ...mapGetters("Cart", [
      "numberOfGuests",
      "homeDelivery",
      "stickerId",
      "customer",
      "address",
      "isOrderTypeDineIn"
    ]),
    ...mapGetters("Theme", [
      "cartProcessInputRadius",
      "addButtonRadius",
      "inputBackground",
      "inputBorder",
      "titleMain",
      "kioskKeyboardBackgroundColor",
      "kioskKeyboardKeyBackgroundColor",
      "kioskKeyboardKeyTextColor",
      "kioskKeyboardTextColor",
      "kioskKeyboardKeysRadius",
      "selectedMenuRoundBackground",
      "userDetailsLabelColor",
      "userDetailsInputBackgroundColor",
      "userDetailsInputTextColor",
    ]),
    filteredMenuRounds() {
      const input = this.menuRoundInput.toLowerCase();
      return this.menu.menu_rounds.filter(option => option.name.toLowerCase().includes(input));
    },
    fullName: {
      get() {
        if (
          this.$cookies.isKey("n") &&
          this.$store.getters["Cart/customer"]["fullName"] == "" &&
          this.$aes.decrypt(decodeURI(this.$cookies.get("n"))) != ""
        ) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("n")));
        }
        return this.$store.getters["Cart/customer"]["fullName"];
      },
      set(value) {
        this.$store.commit("Cart/updateCustomer", {
          field: "fullName",
          value: value,
        });
        let encryptedVisitorName = this.$aes.encrypt(value);
        this.$cookies.set("n", encryptedVisitorName);
        if (value == "") {
          this.$cookies.remove("n");
        }
        // Update note and it will trim out the exceeding characters
        this.note = this.note+"" ;
        this.extraNote = this.extraNote+"" ;

      },
    },
    busNumber: {
      get() {
        return this.$store.state.busNumber;
      },
      set(value) {
        this.$store.commit("updateBusNumber", value);
        
        // Update note and it will trim out the exceeding characters
        this.note = this.note + "";

      },
    },
    address: {
      get() {
        if (this.$cookies.isKey("a")) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("a")));
        }
        return this.$store.state.address;
      },
      set(value) {
        this.$store.commit("updateAddress", value);

        // Update note and it will trim out the exceeding characters
        this.note = this.note+"" ;
        this.extraNote = this.extraNote+"" ;
      },
    },
    vatNumber: {
      get() {
        if (this.$cookies.isKey("v") &&
        this.$store.getters["Cart/customer"]["vatNumber"] == "" &&
        this.$aes.decrypt(decodeURI(this.$cookies.get("v"))) != ""
         ) {
            return this.$aes.decrypt(decodeURI(this.$cookies.get("v")));
            }
        return this.$store.getters["Cart/customer"]["vatNumber"];
        },
       set(value) {
         this.$store.commit("Cart/updateCustomer", {
            field: "vatNumber",
            value: value,
          });
          let encryptedVisitorVatNumber = this.$aes.encrypt(value);
          this.$cookies.set("v", encryptedVisitorVatNumber);
          if (value == "") {
            this.$cookies.remove("v");
           }
        },
    },    
    email: {
      get() {
        return this.$store.getters["Cart/customer"]["email"];
      },
      set(value) {
        let regexEmail = /\S+@\S+\.\S+/;
        if (value == "") {
          this.$cookies.remove("e");
        }
        if (value.match(regexEmail) || value == "") {
          this.$store.commit("updateErrorEmail", false);

        // Update note and it will trim out the exceeding characters
          this.note = this.note + "";
          return this.$store.commit("Cart/updateCustomer", {
            field: "email",
            value: value,
          });
        }
      },
    },
    phone: {
      get() {
        if (
          this.$cookies.isKey("p") &&
          this.$store.getters["Cart/customer"]["phone"] == "" &&
          this.$aes.decrypt(decodeURI(this.$cookies.get("p"))) != ""
        ) {
          return this.$aes.decrypt(decodeURI(this.$cookies.get("p")))
            ? this.$aes.decrypt(decodeURI(this.$cookies.get("p")))
            : "";
        }
        return this.$store.getters["Cart/customer"]["phone"];
      },
      set(value) {
        this.$store.commit("Cart/updateCustomer", {
          field: "phone",
          value: value,
        });
        let encryptedVisitorPhone = this.$aes.encrypt(value);
        this.$cookies.set("p", encryptedVisitorPhone);
        if (value == "") {
          this.$cookies.remove("p");
        }

        // Update note and it will trim out the exceeding characters
        this.note = this.note+"" ;
        this.extraNote = this.extraNote+"" ;
      },
    },
    note: {
      get() {
        return this.$store.getters["Cart/note"];
      },
      set(value) {
        if (value.length > (this.maxPermissibleNoteLen )) {
          value = value.substr(0, this.maxPermissibleNoteLen );
        }
        this.$store.commit("Cart/updateNote", value);
      },
    },
    extraNote: {
      get() {
        if (this.$cookies.isKey("extraNote") &&
        this.$store.getters["Cart/extraNote"]==""&&
        this.$aes.decrypt(decodeURI(this.$cookies.get("extraNote"))) != "")
        {
          
          let value = this.$aes.decrypt(decodeURI(this.$cookies.get("extraNote")));
          this.$store.commit("Cart/updateExtraNote", value);
          return value;
        }          
        return this.$store.getters["Cart/extraNote"];
      },
      set(value) {
        if (this.note.length == 0 && this.totalLengthWithoutNote > this.maxPermissibleTotalLen) {
          value = value.substr(0, this.maxPermissibleTotalLen-this.totalLengthContactDetails);
        }
        this.$store.commit("Cart/updateExtraNote", value);
        let encryptedVisitorExtraNote = this.$aes.encrypt(value);
        this.$cookies.set("extraNote", encryptedVisitorExtraNote);
        if (value == "") {
          this.$cookies.remove("extraNote");
        }
        this.note = this.note + '';

      },
    },
    totalLengthContactDetails(){
      return(""+this.phone+this.email+this.fullName+this.address+this.busNumber).length;
    },
    totalLengthWithoutNote(){
      return(""+this.phone+this.email+this.fullName+this.address+this.busNumber+this.extraNote).length;
    },
    maxPermissibleNoteLen() {
      if (this.totalLengthWithoutNote > this.maxPermissibleTotalLen) return 0;
      if (this.menu.note_max < this.maxPermissibleTotalLen - this.totalLengthWithoutNote) return this.menu.note_max;
      return this.maxPermissibleTotalLen-this.totalLengthWithoutNote;
    },
    maxPermissibleTotalLen() {
      return  this.currentKioskMode && this.currentKioskMode.toLowerCase() === "take out" ? 140: 176 ;
    }
  },
  methods: {
    selectOption(option) {
      // if (option == 'null') {
      //   this.selectedOption = ''
      //   this.$store.commit("updateMenuRound", '');
    // }
      if (option.name == this.selectedOption) {
        this.selectedOption = '';
        this.$store.commit("updateMenuRound", '');
      }
      else {
        this.selectedOption = option.name;
        this.$store.commit("updateMenuRound", option);
      }
      this.isOpen = false; // Close dropdown after selecting an option
    },
     handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.custom-dropdown');
      if (!dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
    onTransitionEnd(event) {
      // Check if the dropdown menu is being closed
      if (!this.isOpen && event.propertyName === 'max-height') {
        // Reset the max-height property after the transition completes
        event.target.style.maxHeight = null;
      }
    },
    toggleDropdown() {
      if (!this.isOpen) {
        this.menuRoundInput = ''
      }
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
        this.$refs.menuRoundInput.focus();
      });
      }
    },
    // holds the type of input field you click on
    getInputType(e) {
      if (typeof e === "object")
        this.inputValue = e.target.closest("input").type;
      else if (typeof e === "string") this.inputValue = e;
    },
    // email validation with regex
      handleBlur(e) {
      let value = e.target.value;
      let regexEmail = /\S+@\S+\.\S+/;
      if (value.match(regexEmail) || value == "") {
        if (value != "") {
          let encryptedVisitorEmail = this.$aes.encrypt(value);
          this.$cookies.set("e", encryptedVisitorEmail);
        }
        this.$store.commit("updateErrorEmail", false);
        return this.$store.commit("Cart/updateCustomer", {
          field: "email",
          value: value,
        });
      } else {
        this.$store.commit("updateErrorEmail", true);
        return this.$store.commit("Cart/updateCustomer", {
          field: "email",
          value: value,
        });
      }
    },
    // check if you type in a number or not
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    accept() {
      if (this.isCickable == '') {
        window.$eventBus.$emit('updateRouteAndProcess');
      }
    },
    show(e) {
      if (this.hasKiosk) {
        this.input = e.target;
        this.layout = layouts[`kiosk_${e.target.dataset.layout}`]||layouts.kiosk;

        if (!this.visible) this.visible = true;
      }
    },
    hide() {
      this.visible = false;
    },
    // saves the delivery addres and distance
    deliveryAddress({ address, transitDistance }) {

      this.$store.commit("updateAddress", address);
      this.$store.commit(
        "updateCalculatedDistanceHomeDelivery",
        transitDistance
      );

      this.$store.commit("updateCurrentAddressesInSearch", []);
    },
    // adds or remove the number of guests
    removeFromNumberOfGuests() {
      this.$store.commit("Cart/updateNumberOfGuests", -1);
    },
    addToNumberOfGuests() {
      this.$store.commit("Cart/updateNumberOfGuests", 1);
    },
    addAddressLoading() {
      this.loadingStatus = true;
      if (this.currentAddressesInSearch == "") {
        setTimeout(() => {
          this.$store.dispatch(
            "GET_LAT_LONG_ADDRESS",
            this.$store.state.address +
              "%20" +
              this.$store.state.zip +
              "%20" +
              this.$store.state.city +
              "%20" +
              this.$store.state.country
          );
          this.loadingStatus = false;
        }, 500);
      }
    },
    addAddress: _.debounce(function () {
      this.$store.dispatch(
        "GET_LAT_LONG_ADDRESS",
        this.$store.state.address +
          "%20" +
          this.$store.state.zip +
          "%20" +
          this.$store.state.city +
          "%20" +
          this.$store.state.country
      );
      this.loadingStatus = false;
    }, 700),
  },
  created() {
      if (this.selectedOption == '' && !this.hasKiosk && this.$store.state.menuRound != '') {
      this.selectedOption = this.$store.state.menuRound.name
    }
      if (sessionStorage.getItem('comoMemberCode') && this.$store.getters["Cart/customer"]["fullName"] == "") {
          this.fullName =  this.$store.getters.member.firstName
        }
    // validation for the button (if you can proceed or not)
    if (!this.hasKiosk) {
      if (this.$cookies.isKey("n")) {
        this.$store.commit("Cart/updateCustomer", {
          field: "fullName",
          value: this.$aes.decrypt(decodeURI(this.$cookies.get("n"))),
        });
      }
      if (this.$cookies.isKey("p")) {
        this.$store.commit("Cart/updateCustomer", {
          field: "phone",
          value: this.$aes.decrypt(decodeURI(this.$cookies.get("p"))),
        });
      }
      if (this.$cookies.isKey("e")) {
        this.$store.commit("Cart/updateCustomer", {
          field: "email",
          value: this.$aes.decrypt(decodeURI(this.$cookies.get("e"))),
        });
        }
       if (this.$cookies.isKey("v")) {
        this.$store.commit("Cart/updateCustomer", {
           field: "vatNumber",
            value: this.$aes.decrypt(decodeURI(this.$cookies.get("v"))),
        });
        }
      this.$aes.setKey("W6{/}m>UU;Kh::+)");
      const keys = Object.values(this.customer);

      if (
        !this.menu.enable_delivery ||
        (this.menu.enable_delivery &&
          localStorage.getItem("currentOption") == "take_away")
      ) {
            if (
            ((this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) &&
            (this.menu.is_checkout_email_enabled ? (keys[1] != "") : true) &&
            (this.menu.is_checkout_phone_enabled ? (keys[2] != "") : true) &&
            !this.errorEmail) ||
            ((this.menu.is_checkout_name_enabled ? (this.$cookies.isKey("n")) : true) &&
            (this.menu.is_checkout_phone_enabled ? this.$cookies.isKey("p") : true) &&
            (this.menu.is_checkout_email_enabled ? this.$cookies.isKey("e") : true) &&
            !this.errorEmail)
        ) {
            this.$store.commit("updateIsCickable", "");
        } else {
          this.$store.commit(
            "updateIsCickable",
            "opacity-40 cursor-not-allowed"
          );
        // }
        }
      } else {
          if (localStorage.getItem("delivery") && this.menu.enable_delivery) {
                if (
                (this.menu.rounds_enabled && (this.$store.state.menuRound != '') ? true : this.address != "" ) &&
                (this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) &&
                (this.menu.is_checkout_email_enabled ? (keys[1] != "") : true) &&
                (this.menu.is_checkout_phone_enabled ? (keys[2] != "") : true) &&
                !this.errorEmail &&
                (this.menu.rounds_enabled && (this.$store.state.menuRound != '') ? true : this.calculatedDistanceHomeDelivery <
                this.menu.max_delivery_distance) &&
                (this.menu.rounds_enabled && (this.$store.state.menuRound != '') ? true : this.calculatedDistanceHomeDelivery != 0)
                ) {
              this.$store.commit("updateIsCickable", "");
            } else {
                this.$store.commit(
                "updateIsCickable",
                "opacity-40 cursor-not-allowed"
                );
            }
        // }        
        }
      }
    }
    else {
      const keys = Object.values(this.customer);
        if (this.menu.show_phone_number) {
                if (
                  ((this.menu.is_checkout_name_enabled ? (keys[0] != ""): true) &&
                   keys[2] != "" && 
                   !this.errorEmail) ||
                  ((this.menu.is_checkout_name_enabled ? this.$cookies.isKey("n") : true) &&
                    this.$cookies.isKey("p") &&
                    !this.errorEmail)
                ) {
                  this.$store.commit("updateIsCickable", "");
                } else {
                  this.$store.commit(
                    "updateIsCickable",
                    "opacity-20 cursor-not-allowed"
                  );
                }
            // }
      } else {
        this.$store.commit("updateIsCickable", "opacity-40 cursor-not-allowed");
              if (
                  ((this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) &&
                  !this.errorEmail) ||
                  ((this.menu.is_checkout_name_enabled ? this.$cookies.isKey("n") : true) && 
                  !this.errorEmail)
              ) {
                this.$store.commit("updateIsCickable", "");
              } else {
                this.$store.commit(
                  "updateIsCickable",
                  "opacity-20 cursor-not-allowed"
                );
              }
          // }
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    let inputFields = document.querySelectorAll("input");
    if (this.menu.layout == 'frydate') {
      for (let i = 0; i < inputFields.length; i++) {
        inputFields[i].style.fontFamily = "Inter";
      }
    }

    /** It will auto focus the input field if the page has just one input field so keyboard will come up */
    document.querySelector('.kioskInput').focus()

    /** This is a temporaray solution to fix the header disappearing issue */
    // this.$nextTick(() => {
    //   let modelCart = document.getElementById('modalCart')
    //   modelCart.style.scrollMargin = '100px'
    //   modelCart.scrollIntoView()
    // })    

    if (!this.menuHash) {
      if (this.stickerId == 0) {
        this.$router.push(`/${this.$route.params.menuHash}`).catch(() => {});
      } else {
        this.$router.push(
          `/${this.$route.params.menuHash}/` + localStorage.getItem("stickerId")
        );
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  updated() {
    if (this.selectedOption == '' && !this.hasKiosk && this.$store.state.roundNumber != '') {
      this.selectedOption = this.$store.state.menuRound.name
    }
    // console.log(
    //   this.fullName +this.phone+ this.email + this.address + this.busNumber + this.note + this.extraNote,
    //   (this.fullName+this.email+this.phone+this.address+this.busNumber+this.note+this.extraNote).length
    // );

    let test = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .control"
    );
    let keys = document.querySelectorAll(
      "body .vue-touch-keyboard .keyboard .key"
    );
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].textContent == "7") {
        keys[i].removeAttribute("style")
      }
      keys[i].style.borderRadius = this.kioskKeyboardKeysRadius;
      keys[i].style.backgroundColor = this.kioskKeyboardKeyBackgroundColor;
      keys[i].style.color = this.kioskKeyboardKeyTextColor;
    }

    for (let i = 0; i < test.length; i++) {
      test[i].style.backgroundColor = this.kioskKeyboardBackgroundColor;
      test[i].style.color = this.kioskKeyboardTextColor;
      test[i].style.borderColor = this.kioskKeyboardBackgroundColor;
    }
    // validation for the button (if you can proceed or not)
    if (!this.hasKiosk) {
      if (this.address === "") {
        this.$store.commit("updateCurrentAddressesInSearch", "");
      }
      const keys = Object.values(this.customer);
          if (
              ((this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) &&
              (this.menu.is_checkout_email_enabled ? (keys[1] != "") : true) && 
              (this.menu.is_checkout_phone_enabled ? (keys[2] != "") : true) && 
              !this.errorEmail) ||
            ((this.menu.is_checkout_name_enabled ? (this.$cookies.isKey("n")) : true) &&
              (this.menu.is_checkout_phone_enabled ? this.$cookies.isKey("p") : true) &&
              (this.menu.is_checkout_email_enabled ? this.$cookies.isKey("e") : true) &&
              !this.errorEmail)
          ) {
            this.$store.commit("updateIsCickable", "");
          } else {
            this.$store.commit("updateIsCickable", "opacity-40 cursor-not-allowed");
          }
      // }
      if (localStorage.getItem("delivery") && this.menu.enable_delivery) {
            if (
              (this.menu.rounds_enabled && (this.$store.state.menuRound != '') ? true : this.address != "" )&&
              (this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) &&
              (this.menu.is_checkout_email_enabled ? (keys[1] != "") : true) &&
              (this.menu.is_checkout_phone_enabled ? (keys[2] != "" ): true) &&
              !this.errorEmail &&
              (this.menu.rounds_enabled && (this.$store.state.menuRound != '')  ? true : this.calculatedDistanceHomeDelivery <
                this.menu.max_delivery_distance) &&
              (this.menu.rounds_enabled && (this.$store.state.menuRound != '')  ? true : this.calculatedDistanceHomeDelivery != 0)
            ) {
              this.$store.commit("updateIsCickable", "");
            } else {
              this.$store.commit(
                "updateIsCickable",
                "opacity-40 cursor-not-allowed"
              );
            }
        // }
      }
    }
    else {
      const keys = Object.values(this.customer);
      if (this.menu.show_phone_number) {
              if ((this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) && 
              keys[2] != "" && 
              !this.errorEmail) {
                  this.$store.commit("updateIsCickable", "");
              } else {
                this.$store.commit(
                  "updateIsCickable",
                  "opacity-20 cursor-not-allowed"
                );
              }
        // }
      } else {
        this.$store.commit("updateIsCickable", "opacity-40 cursor-not-allowed");
            if (
              ((this.menu.is_checkout_name_enabled ? (keys[0] != "") : true) && 
              !this.errorEmail) ||
              ((this.menu.is_checkout_name_enabled ? this.$cookies.isKey("n") : true) && 
              !this.errorEmail)
            ) {
              this.$store.commit("updateIsCickable", "");
            } else {
              this.$store.commit(
                "updateIsCickable",
                "opacity-20 cursor-not-allowed"
              );
            }
        // }
      }
    }
  },
};
</script>

<style scoped>
.borderNone:last-of-type div {
  border: none;
  border-width: 0em;
  border-bottom-width: none;
}

.mobileScroll {
  height: 50vh;
  overflow: scroll;
  margin-bottom: 20px;
}

.dropdown-header::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) rotate(0deg); /* Default position, pointing downwards */
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 7px 0 7px; /* Adjust arrow size */
  border-color: #7d7d7d transparent transparent transparent; /* Adjust arrow color */
}
.custom-dropdown.open .dropdown-header::after {
  transform: translateY(-50%) rotate(180deg); /* Rotate arrow when dropdown is open, pointing upwards */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease; /* Smooth transitions for opacity and transform */
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-20px); /* Initial translateY value for fade in/out */
}
/* .fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
} */

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
}

/* Transition styles */
.dropdown-enter-active, .dropdown-leave-active {
  /* transition: height 0.5s ease, opacity 0.5s ease; */
  transition: all 0.5s ease;
}
.dropdown-enter, .dropdown-leave-to {
  height: 0;
  opacity: 0;
}
</style>